// Mide el ancho de this.$el (o this.$refs.measure) y lo expone como `width`.
// Los gráficos se dibujan en px reales: el texto SVG nunca se escala.
export default {
  data() {
    return { width: 0 };
  },
  mounted() {
    this.$_measure();
    if (typeof ResizeObserver !== "undefined") {
      this.$_ro = new ResizeObserver(() => this.$_measure());
      this.$_ro.observe(this.$refs.measure || this.$el);
    } else {
      window.addEventListener("resize", this.$_measure);
    }
  },
  beforeDestroy() {
    if (this.$_ro) this.$_ro.disconnect();
    window.removeEventListener("resize", this.$_measure);
  },
  methods: {
    $_measure() {
      const el = this.$refs.measure || this.$el;
      const w = el && el.clientWidth ? el.clientWidth : 0;
      if (w && Math.abs(w - this.width) > 0.5) this.width = w;
    },
  },
};
